/**
  Locale strings for Genesis system.
**/
module.exports = {
  WELCOME_BACK: {
    en: 'Welcome Back',
    zh: '欢迎回来'
  },
  LOGOUT: {
    en: 'Logout',
    zh: '退出账号'
  },
  PAGE: {
    en: 'Page',
    zh: '页面'
  },
  PAGES: {
    en: 'Pages',
    zh: '页面'
  },
  ASSETS: {
    en: 'Assets',
    zh: '页面'
  },
  APPROVALS: {
    en: 'Approvals',
    zh: '审批'
  },
  REPORT: {
    en: 'Reports',
    zh: '报告'
  },
  CATEGORIES: {
    en: 'Categories',
    zh: '页面分类'
  },
  DEPLOY: {
    en: 'Deploy',
    zh: '发布'
  },
  NAME: {
    en: 'name',
    zh: '名称'
  },
  PUBLISH_APPROVALS: {
    en: 'Publish approvals',
    zh: '发布审批'
  },
  MY_PUBLISH_HISTORY: {
    en: 'My publish history',
    zh: '我的发布历史'
  },
  DELETING_APPROVALS: {
    en: 'Deleting approvals',
    zh: '删除审批'
  },
  ALL_DELETING_HISTORY: {
    en: 'All deleting history',
    zh: '删除记录'
  },
  ROLES: {
    en: 'Roles',
    zh: '权限'
  },
  TITLE: {
    en: 'Title',
    zh: '标题'
  },
  PATH: {
    en: 'Path',
    zh: '路径'
  },
  PATH_WITH_NOTE: {
    en: 'Path (only alphabet, number, -, _ allowed)',
    zh: '路径 （只允许字母数字_-）'
  },
  CANONICAL_RELATIONSHIP: {
    en: 'Canonical Relationship URL',
    zh: ''
  },
  CATEGORY: {
    en: 'Category',
    zh: '页面分类'
  },
  LAST_UPDATED: {
    en: 'Last Updated',
    zh: '最后更新于'
  },
  UPDATED_BY: {
    en: 'Updated By',
    zh: '最后修改人'
  },
  STATE: {
    en: 'State',
    zh: '状态'
  },
  ALL_PAGES: {
    en: 'All Pages',
    zh: '所有页面'
  },
  NEW_PAGE: {
    en: 'New Page',
    zh: '新建页面'
  },
  VERSIONS: {
    en: 'Versions',
    zh: '版本'
  },
  VERSION: {
    en: 'Version',
    zh: '版本'
  },
  EDIT: {
    en: 'Edit',
    zh: '编辑'
  },
  COPY: {
    en: 'Copy',
    zh: '复制'
  },
  DELETE: {
    en: 'Delete',
    zh: '删除'
  },
  ARE_YOU_SURE_TO_DELETE: {
    en: 'Are you sure you want to delete',
    zh: '确定删除'
  },
  ARE_YOU_SURE_TO_WITHDRAW: {
    en: 'Are you sure you want to withdraw',
    zh: 'ARE_YOU_SURE_TO_WITHDRAW'
  },
  ARE_YOU_SURE_TO_DEPLOY: {
    en: 'Are you sure you want to deploy this now?',
    zh: '请确认立刻发布'
  },
  ARE_YOU_SURE_TO_CANCEL_SCHEDULE: {
    en: 'Are you sure you want to cancel this deployment?',
    zh: '请确认取消预约'
  },
  YES_CANCEL: {
    en: 'Yes, cancel',
    zh: '确认'
  },
  SAVE: {
    en: 'Save',
    zh: '保存'
  },
  CANCEL: {
    en: 'Cancel',
    zh: '取消'
  },
  MANAGE_CATEGORIES: {
    en: 'Manage Categories',
    zh: '管理页面分类'
  },
  VIEW_PAGES: {
    en: 'View Pages',
    zh: '显示网页'
  },
  WHAT_IS_CATEGORY_FOR: {
    en: 'What is this category for?',
    zh: '此页面分类的作用'
  },
  ADD: {
    en: 'Add',
    zh: '添加'
  },
  ADD_CATEGORY: {
    en: 'Add Category',
    zh: '新建分类'
  },
  FULL_PAGE_WILL_BE: {
    en: 'Full path will be',
    zh: '完整路径为'
  },
  EDITING: {
    en: 'Editing',
    zh: '正在编辑'
  },
  APPROVE: {
    en: 'Approve',
    zh: '批准'
  },
  REJECT: {
    en: 'Reject',
    zh: '拒绝'
  },
  PLEASE_CONFIRM_TO: {
    en: 'Please confirm to',
    zh: '请确认'
  },
  PREVIEW: {
    en: 'Preview',
    zh: '预览'
  },
  PREVIEW_DESKTOP: {
    en: 'Desktop Preview',
    zh: 'Desktop Preview'
  },
  PREVIEW_TABLET: {
    en: 'Tablet Preview',
    zh: 'Tablet Preview'
  },
  PREVIEW_MOBILE: {
    en: 'Mobile Preview',
    zh: 'Mobile Preview'
  },
  SUCCESS_SAVE_PAGE: {
    en: 'Successfully saved page!',
    zh: '保存页面成功！'
  },
  SUCCESS_SAVE_SETTINGS: {
    en: 'Successfully saved settings!',
    zh: '保存设置成功'
  },
  ERROR_SAVE_PAGE: {
    en: 'Unable to save changes. Please ensure the category + path is unique.',
    zh: '无法保存更改。 请确保类别+路径是唯一的。'
  },
  HERE: {
    en: 'here',
    zh: '这里'
  },
  PREVIEW_WARNING_FIRST: {
    en: 'You are previewing version',
    zh: '您正在预览本页面的版本'
  },
  PREVIEW_WARNING_SECOND: {
    en: 'of this page, click',
    zh: '请点击'
  },
  PREVIEW_WARNING_THIRD: {
    en: 'to go back to your draft, or save the page to apply changes.',
    zh: '回到页面草稿，或在本页保存修改。'
  },
  TEMPLATE: {
    en: 'Template',
    zh: '模板'
  },
  TEMPLATE_VERSION: {
    en: 'Template Version',
    zh: '模板版本'
  },
  SAVE_AS_VERSION: {
    en: 'SAVE AS VERSION',
    zh: '保存为版本'
  },
  VERSION_NUMBER: {
    en: 'Version Number',
    zh: '版本号'
  },
  NEXT_VERSION_NUMBER: {
    en: 'Next Version Number',
    zh: '下一个版本号'
  },
  VERSION_NUMBER_REQUIREMENT: {
    en: 'Version number should be unique and identifiable',
    zh: '版本号应唯一且方便识别'
  },
  NOTES: {
    en: 'Notes',
    zh: '备注'
  },
  NOTES_REQUIREMENT: {
    en: 'A brief note about this version.',
    zh: '关于该版本的简短备注'
  },
  SAVE_DRAFT: {
    en: 'SAVE DRAFT',
    zh: '保存草稿'
  },
  REVERT: {
    en: 'Revert',
    zh: '还原'
  },
  PUBLISH: {
    en: 'Publish',
    zh: '发布'
  },
  DEPLOY_MESSAGE: {
    en: 'There are new approvals since the last deployment which are not currently live. Please create a new deployment to push these changes to ff.com.',
    zh: '我们监测到有新的发布请求。请创建新的部署将更新内容发布到 ff.com'
  },
  CHECK_BEFORE_PUBLISH: {
    en: 'Please check the page for issues before publishing.',
    zh: '请在发布前检查页面。'
  },
  ACTIVE_DEPLOYMENT: {
    en: 'ACTIVE DEPLOYMENT',
    zh: '当前在线版本'
  },
  DEPLOYMENT_HISTORY: {
    en: 'DEPLOYMENT HISTORY',
    zh: '发布历史'
  },
  DEPLOYMENTS: {
    en: 'Deployments',
    zh: '发布记录'
  },
  DATE: {
    en: 'Date',
    zh: '日期'
  },
  DEPLOYED_BY: {
    en: 'Deployed By',
    zh: '发布人'
  },
  GIT_COMMIT_SHA: {
    en: 'GIT_COMMIT_SHA',
    zh: 'GIT_COMMIT_SHA'
  },
  ROLL_BACK: {
    en: 'Roll Back',
    zh: '回滚'
  },
  DEPLOY_NOW: {
    en: 'Deploy Now',
    zh: '现在发布'
  },
  REDEPLOY: {
    en: 'Redeploy',
    zh: '重新发布'
  },
  REDEPLOY_ALL: {
    en: 'Redeploy All',
    zh: '重新发布当前网站'
  },
  REDEPLOY_SELECTED: {
    en: 'Redeploy Selected Pages',
    zh: '重新发布所选页面'
  },
  SHOW_ALL: {
    en: 'Show All',
    zh: '全部'
  },
  ADDITIONS: {
    en: 'Additions',
    zh: '新增内容'
  },
  USER: {
    en: 'User',
    zh: '用户'
  },
  MODIFICATIONS: {
    en: 'Modifications',
    zh: '修改内容'
  },
  DELETIONS: {
    en: 'Deletions',
    zh: '删除内容 '
  },
  DELETION: {
    en: 'Deletion',
    zh: '移除页面'
  },
  WITHDRAW_PUBLISH: {
    en: 'Withdraw Publish',
    zh: 'WITHDRAW_PUBLISH'
  },
  WITHDRAW: {
    en: 'Withdraw',
    zh: 'WITHDRAW'
  },
  ADDITION: {
    en: 'Addition',
    zh: '添加页面'
  },
  PENDING_DEPLOY: {
    en: 'Pending Deployment',
    zh: '待发布'
  },
  TO_DEPLOY_MESSAGE: {
    en: 'To deploy the site, first select a version number for this deployment.',
    zh: '请输入本次发布的版本号'
  },
  CHECK_GLOBAL_COVERAGE: {
    en: 'Check Global Coverage',
    zh: '确认区域选择'
  },
  OK: {
    en: 'OK',
    zh: 'OK'
  },
  FOLLOW_PAGES_NOT_GLOBALLY_COVERED_MESSAGE: {
    en: 'The folloiwng pages are only available in one region:',
    zh: '以下页面只存在于一个区域：'
  },
  ALL_PAGES_GLOABLLY_COVERED_MESSAGE: {
    en: 'All pages have reached global coverage!',
    zh: '所有页面全球覆盖!'
  },
  THIS_IS_A: {
    en: 'This is a ',
    zh: '这是'
  },
  UNIQUE_PAGE: {
    en: '-unique page.',
    zh: '独特页面'
  },
  GLOBAL_COVERAGE_REGION_CN: {
    en: 'CN',
    zh: '中国区'
  },
  GLOBAL_COVERAGE_REGION_US: {
    en: 'US',
    zh: '英文区'
  },
  TMEPLATE_SETTINGS: {
    en: 'Template Settings',
    zh: '模板设置'
  },
  EDIT_TEMPLATE_SETTINGS: {
    en: 'Edit Template Settings',
    zh: '编辑模板设置'
  },
  DELETED: {
    en: 'DELETED',
    zh: '已删除'
  },
  WITHDREW: {
    en: 'WITHDREW',
    zh: '已撤回'
  },
  DEPLOYED: {
    en: 'DEPLOYED',
    zh: '已发布'
  },
  DELETE_DECLINED: {
    en: 'DELETE_DECLINED',
    zh: '删除请求拒绝'
  },
  UNDER_REVIEW: {
    en: 'UNDER_REVIEW',
    zh: '审核中'
  },
  PENDING_DELETE: {
    en: 'Deletion Pending',
    zh: '删除待处理'
  },
  // Mapping for page states
  PENDING_REMOVAL: {
    en: 'Withdraw Publish Pending',
    zh: 'PENDING_REMOVAL'
  },
  REMOVED: {
    en: 'Publish Withdrawn',
    zh: 'REMOVED'
  },
  ADD_COMPONENT: {
    en: 'Add widget',
    zh: '添加组件'
  },
  MORE_WIDGETS: {
    en: 'Find more widgets ->',
    zh: '更多组件'
  },
  SETTINGS: {
    en: 'Settings',
    zh: '设置'
  },
  CREATED_ON: {
    en: 'Created On',
    zh: '创建时间'
  },
  CREATED_BY: {
    en: 'Created By',
    zh: '创建人'
  },
  USERNAME: {
    en: 'Username',
    zh: '用户名'
  },
  EMAIL: {
    en: 'Email',
    zh: '电子邮箱'
  },
  CREATOR: {
    en: 'Creator',
    zh: '创建者'
  },
  ADMIN: {
    en: 'Admin',
    zh: '管理员'
  },
  ACTIVE: {
    en: 'Active',
    zh: '已激活'
  },
  ACTION: {
    en: 'Action',
    zh: '操作'
  },
  ROLE_LIST: {
    en: 'Role List',
    zh: '用户目录'
  },
  ADD_USER: {
    en: 'Add user',
    zh: '添加用户'
  },
  SEARCH: {
    en: 'Search',
    zh: '搜索'
  },
  SEARCH_HELP_TEXT: {
    en: 'type at least 3 characters to search for user',
    zh: '搜索用户名(输入3个或以上字母)'
  },
  NO_SEARCH_MATCH: {
    en: 'No result matched',
    zh: '没有符合搜索条件的结果'
  },
  APPROVAL_LIST: {
    en: 'Approval List',
    zh: '审批目录'
  },
  SUBMITTED_ON: {
    en: 'Submitted on',
    zh: '提交时间'
  },
  SUBMITTED_BY: {
    en: 'Submitted by',
    zh: '提交人'
  },
  BLOCK: {
    en: 'Block',
    zh: '封锁'
  },
  UNBLOCK: {
    en: 'Unblock',
    zh: '解锁'
  },
  REMOVE: {
    en: 'Remove',
    zh: '移除'
  },
  REMOVE_ALL: {
    en: 'Remove all',
    zh: '移除全部'
  },
  ADD_ALL: {
    en: 'Add all',
    zh: '添加全部'
  },
  ROLE_MANAGEMENT: {
    en: 'Role management',
    zh: '权限管理'
  },
  ERROR_PUBLISH_NO_USER: {
    en: 'You must be signed in to publish a page!',
    zh: '请先登录后再请求发布页面！'
  },
  ERROR_PUBLISH_NONEXISTENT_PAGE: {
    en: 'The page you tried to publish does not exist.',
    zh: '您请求发布的页面不存在。'
  },
  ERROR_PUBLISH_NONEXISTENT_VERSION: {
    en: 'The version you tried to publish does not exist.',
    zh: '您请求发布的页面版本不存在。'
  },
  ERROR_PUBLISH_CONFLICT: {
    en: `This page can not be published because there is another pending request to
    publish this page already. Before this page can be published, the
    conflicting publish request must either be deleted or deployed. If you have
    the proper permissions, you can do this on the approvals tab, or have an
    authorized user do this for you if you don't.`,
    zh: '您的请求无法通过，因为该页面已在发布审核中。在对该页面进行发布请求之前，请驳回或通过此前已存在的发布请求。如果您有管理员权限，可以通过审核页面进行此操作；或请联系有该权限的用户进行协助。'
  },
  ERROR_PUBLISH_SCHEDULED: {
    en: `This page can not be published because there is a pending scheduled deployment`,
    zh: '您的请求无法通过，因为该页面已预约发布'
  },
  PUBLISH_SUCCESS: {
    en: 'Your publish request has been submitted. Before the page can go live on the site, it must be approved by a user with the proper permissions. If you have these permissions, you may approve it yourself.',
    zh: '您的发布请求已提交。页面将在请求通过管理员审核后发布。如果您有管理员权限，可在审核页面自行通过该请求。'
  },
  PUBLISHED_VERSION: {
    en: 'PUBLISHED',
    zh: '已发布'
  },
  WIDGET_PRESETS: {
    en: 'Widget Presets',
    zh: '预设插件'
  },
  WIDGET_TITLE: {
    en: 'Widget',
    zh: '插件'
  },
  NEW_PRESET: {
    en: 'New Preset',
    zh: '添加预设'
  },
  MESSAGE_SUCCESS_REMOVE_PRESET: {
    en: 'Successfully deleted the preset.',
    zh: '成功删除该项预设'
  },
  MESSAGE_SUCCESS_UPDATE_PRESET: {
    en: 'Successfully updated the preset.',
    zh: '成功更新该项预设'
  },
  PAGE_LIST: {
    en: 'Page List',
    zh: '页面列表'
  },
  PAGES_USING: {
    en: 'Pages Using',
    zh: '正在使用'
  },
  NO_PAGE_FOUND: {
    en: 'No page was found using this preset',
    zh: '没有页面正在使用该预设'
  },
  EDIT_NOT_ALLOWED: {
    en: 'Edit and save props are not allowed as preset is in use. Please remove the preset first!',
    zh: '使用插件预设的插件不能编辑、保存。请先取消预设关联，再进行修改。'
  },
  REDEPLOY_ALL_CONFIRM: {
    en: 'REDEPLOY ALL triggers a rebuild of all pages that are currently on production. This is a very costly way of deployment as it requires re-rendering of all pages. Use this only when there is an update on widget presets or any other changes that have global impact.',
    zh: '重新发布全部在线网页，请谨慎使用。'
  },
  CONFIRM_DEPLOY: {
    en: 'Confirm to Deploy',
    zh: '确认发布'
  },
  DEPLOY_VERSION: {
    en: 'Deploy Version',
    zh: '发布版本'
  },
  DEPLOYING: {
    en: 'Deploying',
    zh: '发布中'
  },
  PENDING_DEPLOY_TITLE: {
    en: 'Pending Deployment',
    zh: ''
  },
  YES_DEPLOY: {
    en: 'Yes, Deploy',
    zh: '确认发布'
  },
  ERROR: {
    en: 'Error!',
    zh: '错误！'
  },
  SUCCESS: {
    en: 'Success!',
    zh: '成功！'
  },
  NO_PAGE_PENDING_DEPLOY: {
    en: 'There is no page changes pending deploy.',
    zh: '没有找到等待发布的页面'
  },
  ERROR_FAILED_DEPPLOYMENT: {
    en: 'Deployment failed due to the following error(s):',
    zh: '发布失败，错误信息如下：'
  },
  TYPE: {
    en: 'Type',
    zh: '类型'
  },
  SERVER_FAILURE: {
    en: 'Server is temporarily unavailable. Your deployment is aborted.',
    zh: '服务暂时不可用，你的发布请求已取消。'
  },
  RECONNECTING: {
    en: 'Lost connection. Attempting to reconnect...',
    zh: ''
  },
  SCHEDULE: {
    en: 'schedule',
    zh: '预约'
  },
  SCHEDULED: {
    en: 'scheduled',
    zh: '已预约'
  },
  TIME: {
    en: 'time',
    zh: '时间'
  },
  ERROR_NOT_WITHIN_HOURS: {
    en: 'Scheduled deployment must be set up {} hours ahead.',
    zh: '请提前{}小时以上预约发布'
  },
  ERROR_NOT_IN_PAST: {
    en: 'Scheduled deployment cannot be in the past.',
    zh: '预约发布不能在过去的时间'
  },
  SCHEDULED_DEPLOYMENT: {
    en: 'Scheduled Deployments',
    zh: '已预约发布'
  },
  DATE_AND_TIME: {
    en: 'Date & TIME',
    zh: '发布时间'
  },
  SCHEDULED_BY: {
    en: 'Scheduled By',
    zh: '发布人'
  },
  CONFIRM_CHANGES: {
    en: 'Confirm Changes',
    zh: '确认修改'
  },
  ERROR_NO_SCHEDULE_WITHIN_MIN_MINS: {
    en: 'Two deployments have to be set at least {min} minutes apart. Conflicted with deployment {version}',
    zh: '两次预约发布的间隙不得小于{min}分钟。与发布{version}有冲突'
  },
  ERROR_NO_MORE_THAN_MAX_SCHEDULED: {
    en: 'A maximum of {} scheduled deployments can be set at a given time.',
    zh: '最多可同时预约{}个发布'
  },
  SUCCESS_UPDATE_SCHEDULE: {
    en: 'The deployment was successfully updated.',
    zh: '成功修改预约时间！'
  },
  SUCCESS_CANCEL_SCHEDULE: {
    en: 'The deployment was successfully cancelled.',
    zh: '成功取消预约发布！'
  },
  SUCCESS_DELETE_FAILED: {
    en: 'The failed deployment was successfully deleted.',
    zh: '成功刪除失败发布！'
  },
  ERROR_SCHEDULE_CONFLICT: {
    en: 'The page you requested for publish is already scheduled for deployment. Please send request after the deployment is done.',
    zh: '该页面已预约发布，请在发布后再提交发布申请。'
  },
  SCHEDULED_REBUILD: {
    en: 'If there are deployments scheduled, Redeploy All will trigger rebuilding of all the pages scheduled as well.',
    zh: '选择重新发布也将重新组建、绘制所有预约发布中的页面。'
  },
  STATUS: {
    en: 'Status',
    zh: 'Status'
  },
  MEDIA_LIBRARY: {
    en: 'Media library',
    zh: '媒体库'
  },
  UPLOAD_NEW: {
    en: 'Upload new',
    zh: '上传新的'
  },
  ADD_FOLDER: {
    en: 'Add Folder',
    zh: '新增文件夹'
  },
  CREATE: {
    en: 'Create',
    zh: '创建'
  },
  NEW_FOLDER_NAME: {
    en: 'New Folder Name',
    zh: '新文件夹名称'
  },
  ALL_CATEGORIES: {
    en: 'All categories',
    zh: '上传新的'
  },
  COPY_URL: {
    en: 'Copy URL',
    zh: '复制网址'
  },
  ASSETS_IMAGES: {
    en: 'Images',
    zh: '图片'
  },
  ASSETS_VIDEOS: {
    en: 'Videos',
    zh: '视频'
  },
  ERROR_CREATE_PAGE_CATEGORY: {
    en: 'You don\'t have permission to create page in this category.',
    zh: '您没有权限在此类别创建页面'
  },
  ERROR_CREATE_PAGE_PATH_SLUG: {
    en: 'only alphabets numbers "_" "-" are allowed in slug',
    zh: '仅允许输入字母，数字和"_" "-"'
  },
  SELECT_ASSET: {
    en: 'Select Asset',
    zh: '选择资源'
  },
  EDITOR_HIGHLIGHT_EMPTY_URL: {
    en: 'Click EDIT to add a link',
    zh: '点击编辑以添加链接'
  },
  DRAG_FILES_HERE: {
    en: 'Drag files here',
    zh: '拖放文件到这里'
  },
  OPEN_APP: {
    en: 'Open App',
    zh: '打开App'
  },
  LOAD_MORE: {
    en: 'Load More',
    zh: '查看更多'
  },
  ALL_TIME: {
    en: 'All Time',
    zh: '所有时间'
  },
  VIEWS: {
    en: 'views',
    zh: '阅读'
  },
  NO_SEARCH_RESULT: {
    en: 'No search results found',
    zh: '沒有搜索结果'
  },
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_MOBILE: {
    en: 'Image size 1179 * 2556px is preferred, 72dpi ≤ resolution ≤ 75dpi',
    zh: '图片尺寸以1179*2556px以内为佳，72dpi≤分辨率≤75dpi'
  },
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_DESKTOP: {
    en: 'Image size 3456 * 1970px or 2048 * 1280px is preferred, 72dpi ≤ resolution ≤ 75dpi',
    zh: '图片尺寸3456*1970px or 2048*1280px为佳，72dpi≤分辨率≤75dpi'
  },
  ASSET_SAME_FILE_NAME: {
    en: 'A file with the same name already exists. Do you want to replace it?',
    zh: '同名文件已存在。您要替换它吗?'
  },
};
